type FooterLink = {
  label: string;
  url: string;
  key?: string; // optional in case not all links have it
};

type FooterSection = {
  title: string;
  links: FooterLink[];
};

type AppLinks = {
  sections: FooterSection[];
};

export const filterFooterAppLinks = (
  appLinks: AppLinks,
  allowedPages?: Record<string, boolean>,
  externalCurrencyEnabled?: boolean
): AppLinks => {
  if (!allowedPages) return appLinks;

  return {
    sections: appLinks.sections
      .map((section) => ({
        ...section,
        links: section.links.filter((link) => {
          // If there's no key, consider it allowed by default
          if (!link.key) return true;
          // Hide "Buy Twin Points" when external currency is enabled
          if (externalCurrencyEnabled && link.key === 'buy_points') {
            return false;
          }
          const allowed = allowedPages[link.key];
          return allowed === undefined || allowed === true;
        }),
      }))
      // Only keep sections that still have links after filtering
      .filter((section) => section.links.length > 0),
  };
};
